export default __webpack_public_path__ + "static/media/etc.85860af5.svg";